import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import DialogContent from '@material-ui/core/DialogContent';

import './SupplierDataChangeTranslate';
import paths from '../../_helpers/paths';
import { history } from '../../_helpers/history';
import Modal from '../../_ui/Modal/Modal';
import {
  StyledModalContainer,
  TableWrapper
} from '../ServiceRequest/ServiceProvidersModal/ServiceProvidersModalStyles';
import SupplierDataChangeTable from './SupplierDataChangeTable';

const StickyHeaderFix = styled.div`
  padding-top: 8px;

  .ReactTable {
    border-top: 1px solid rgba(125, 125, 125, 0.4) !important;
  }
  .rt-thead.-header {
    top: 0 !important;
  }
  .rt-thead.-filters {
    top: 40px !important;
  }
`;

function SupplierListKindergartenPage({ modal }) {
  const { t } = useTranslation();
  const close = modal ? modal.close : () => history.push(paths.homePage);

  const onClickRow = ({ original }) => {
    if (modal) modal.close();
    history.push(`/supplier-data-change/id=${original.id}`);
  };

  return (
    <Modal
      open
      maxWidth="lg"
      title={t('supplierDataChange_title')}
      onClose={close}
      scroll="paper"
    >
      <DialogContent dividers>
        <div className="overflow-auto">
          <StyledModalContainer>
            <TableWrapper>
              <StickyHeaderFix>
                <SupplierDataChangeTable index={3} onClickRow={onClickRow} />
              </StickyHeaderFix>
            </TableWrapper>
          </StyledModalContainer>
        </div>
      </DialogContent>
    </Modal>
  );
}

export default SupplierListKindergartenPage;
